module.exports = __webpack_public_path__ + "img/010-judge.233fda93.png";